export default function ({ store, redirect, route }) {
  const unAuthRoutes = store.state.unAuthRoutes

  if (sessionStorage.getItem('Token')) {
    if (unAuthRoutes.includes(route.path)) {
      redirect('/measurements/rf/')
    }
  }
}
